// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"4e17e35b","494":"57809df2","517":"aefdc0ba","718":"15ffbf0d","893":"c9ae5228"}[chunkId] + ".chunk.css";
};